export const tipoEstoqueOptions = [
  { label: 'Entrada', value: 'E' },
  { label: 'Saída', value: 'S' },
];
